var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 40,
    viewBox: "0 0 204 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_480_2908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0328 40L98.3376 11.8466H150.971L150.083 16.9848H116.952L115.913 22.8011H147.403L146.515 28.0285H114.932L113.705 34.7725H147.572L146.629 40H92.995H93.0328ZM178.797 27.9393L183.158 5.19179H203.056L204 0H100.452L99.508 5.13827H162.373L158.107 27.8858L178.797 27.9215V27.9393ZM19.4636 27.9393L22.7862 9.84835L43.9867 21.6949L69.548 9.93756L66.131 27.9393H85.5569L90.6918 0.0356824H72.2099L45.8368 11.9715L23.8812 0H5.21044L0 27.9393H19.4636Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_480_2908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMet);
export default __webpack_public_path__ + "static/media/met.5c500b86bb3c46ef021856ad2a603898.svg";
export { ForwardRef as ReactComponent };